import { CompositeSessionInfoSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';

import { AppState } from '../../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../../codegen/Localize';
import { ICollectionInfo } from '../../../../Collections/space/ICollectionInfo';
import { setOwner } from '../../../actions/SetOwnerAction';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { userCanManageAnyCollection } from './IEntityActionHelpers';

export const SetCollectionOwnerEntityAction: IEntityAction<ICollectionInfo, {}> = {
  name: EntityActionNames.SetOwner,
  translateName: Messages.changeOwner_action,
  isVisible: () => {
    return true;
  },
  isClickable: (_availableActions: {}, targetItems: ICollectionInfo[], state: AppState) => {
    return !CompositeSessionInfoSelectors.isLimitedUserVisibilityEnforced(state) && userCanManageAnyCollection(state, targetItems);
  },
  createReduxAction: (targetItems: ICollectionInfo[]) => setOwner(targetItems)
};
